import flatpickr from 'flatpickr';
import italian from 'flatpickr/dist/l10n/it.js';
import confirmDate from 'flatpickr/dist/plugins/confirmDate/confirmDate.js';
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";

$(document).on('turbolinks:load', function() {
  // Generic
  flatpickr('.datetimepicker', {
    locale: 'it',
    enableTime: true,
    plugins: [
      new confirmDate({
        confirmIcon: "<i class='bi bi-check-lg'></i>",
        confirmText: '',
        showAlways: true,
      }),
    ],
    defaultHour: new Date().getHours(),
    defaultMinute: new Date().getMinutes(),
    minuteIncrement: 1,
    time_24hr: true,
    altInput: true,
    altFormat: 'F j, Y H:i',
    dateFormat: 'Z',
  });

  flatpickr('.datepicker', {
    locale: 'it',
    plugins: [
      new confirmDate({
        confirmIcon: "<i class='bi bi-check-lg'></i>",
        confirmText: '',
        showAlways: true,
      }),
    ],
    altInput: true,
    altFormat: 'F j, Y',
  });

  flatpickr('.monthpicker', {
    locale: 'it',
    plugins: [
      new monthSelectPlugin({
         shorthand: true, //defaults to false
          dateFormat: "d/m/Y", //defaults to "F Y"
          altFormat: "F Y", //defaults to "F Y"
      }),
    ],
    altInput: true,
  });

  flatpickr('.timepicker', {
    locale: 'it',
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
    time_24hr: true,
  });

  // START_TIME END_TIME 1m
  let start_time = flatpickr('#start_time', {
    locale: 'it',
    enableTime: true,
    plugins: [
      new confirmDate({
        confirmIcon: "<i class='bi bi-check-lg'></i>",
        confirmText: '',
        showAlways: true,
      }),
    ],
    defaultHour: new Date().getHours(),
    defaultMinute: new Date().getMinutes(),
    minuteIncrement: 1,
    time_24hr: true,
    altInput: true,
    altFormat: 'F j, Y H:i',
    dateFormat: 'Z',
    maxDate: getElementValue('#end_time'),
    onChange: function(selectedDates, dateStr, instance) {
      end_time.set('minDate', dateStr);
    },
  });

  let end_time = flatpickr('#end_time', {
    locale: 'it',
    enableTime: true,
    plugins: [
      new confirmDate({
        confirmIcon: "<i class='bi bi-check-lg'></i>",
        confirmText: '',
        showAlways: true,
      }),
    ],
    defaultHour: new Date().getHours(),
    defaultMinute: new Date().getMinutes(),
    minuteIncrement: 1,
    time_24hr: true,
    altInput: true,
    altFormat: 'F j, Y H:i',
    dateFormat: 'Z',
    minDate: getElementValue('#start_time'),
    onChange: function(selectedDates, dateStr, instance) {
      start_time.set('maxDate', dateStr);
    },
  });

  // START_TIME END_TIME 15m
  let start_time_inc_15 = flatpickr('#start_time_inc_15', {
    locale: 'it',
    enableTime: true,
    plugins: [
      new confirmDate({
        confirmIcon: "<i class='bi bi-check-lg'></i>",
        confirmText: '',
        showAlways: true,
      }),
    ],
    minuteIncrement: 15,
    time_24hr: true,
    altInput: true,
    altFormat: 'F j, Y H:i',
    dateFormat: 'Z',
    maxDate: getElementValue('#end_time_inc_15'),
    onChange: function(selectedDates, dateStr, instance) {
      end_time_inc_15.set('minDate', dateStr);
    },
  });

  let end_time_inc_15 = flatpickr('#end_time_inc_15', {
    locale: 'it',
    enableTime: true,
    plugins: [
      new confirmDate({
        confirmIcon: "<i class='bi bi-check-lg'></i>",
        confirmText: '',
        showAlways: true,
      }),
    ],
    minuteIncrement: 15,
    time_24hr: true,
    altInput: true,
    altFormat: 'F j, Y H:i',
    dateFormat: 'Z',
    minDate: getElementValue('#start_time_inc_15'),
    onChange: function(selectedDates, dateStr, instance) {
      start_time_inc_15.set('maxDate', dateStr);
    },
  });
  // CLOSING_FROM CLOSING_TO
  let closing_from = flatpickr('#closing_from', {
    locale: 'it',
    plugins: [
      new confirmDate({
        confirmIcon: "<i class='bi bi-check-lg'></i>",
        confirmText: '',
        showAlways: true,
      }),
    ],
    altInput: true,
    altFormat: 'F j, Y',
    maxDate: getElementValue('#closing_to'),
    onChange: function(selectedDates, dateStr, instance) {
      closing_to.set('minDate', dateStr);
    },
  });

  let closing_to = flatpickr('#closing_to', {
    locale: 'it',
    plugins: [
      new confirmDate({
        confirmIcon: "<i class='bi bi-check-lg'></i>",
        confirmText: '',
        showAlways: true,
      }),
    ],
    altInput: true,
    altFormat: 'F j, Y',
    dateFormat: 'Z',
    minDate: getElementValue('#closing_from'),
    onChange: function(selectedDates, dateStr, instance) {
      closing_from.set('maxDate', dateStr);
    },
  });

  // START_FROM START_TO
  let start_from = flatpickr('#start_from', {
    locale: 'it',
    plugins: [
      new confirmDate({
        confirmIcon: "<i class='bi bi-check-lg'></i>",
        confirmText: '',
        showAlways: true,
      }),
    ],
    altInput: true,
    altFormat: 'F j, Y',
    maxDate: getElementValue('#start_to'),
    onChange: function(selectedDates, dateStr, instance) {
      start_to.set('minDate', dateStr);
    },
  });

  let start_to = flatpickr('#start_to', {
    locale: 'it',
    plugins: [
      new confirmDate({
        confirmIcon: "<i class='bi bi-check-lg'></i>",
        confirmText: '',
        showAlways: true,
      }),
    ],
    altInput: true,
    altFormat: 'F j, Y',
    minDate: getElementValue('#start_from'),
    onChange: function(selectedDates, dateStr, instance) {
      start_from.set('maxDate', dateStr);
    },
  });
  let time_picker_start_inc_30 = flatpickr('#time_picker_start_inc_30', {
    locale: 'it',
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
    time_24hr: true,
    minuteIncrement: 30,
    plugins: [
      new confirmDate({
        confirmIcon: "<i class='bi bi-check-lg'></i>",
        confirmText: '',
        showAlways: true,
      }),
    ],
    maxDate: getElementValue('#time_picker_end_inc_30'),
    onChange: function(selectedDates, dateStr, instance) {
      time_picker_end_inc_30.set('minDate', dateStr);
    },
  });

  let time_picker_end_inc_30 = flatpickr('#time_picker_end_inc_30', {
    locale: 'it',
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
    time_24hr: true,
    minuteIncrement: 30,
    plugins: [
      new confirmDate({
        confirmIcon: "<i class='bi bi-check-lg'></i>",
        confirmText: '',
        showAlways: true,
      }),
    ],
    minDate: getElementValue('#time_picker_start_inc_30'),
    onChange: function(selectedDates, dateStr, instance) {
      time_picker_start_inc_30.set('maxDate', dateStr);
    },
  });
});
